import React, {PureComponent} from "react"
import {Moment} from "moment"

import {FormattedMessage} from "@irati/utils/lang"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import Button from "@irati/ui/src/Button"
import {calculateCountdown} from "@irati/deals/helpers/deals/countdown"
import {H4} from "@irati/ui/src/Typography"

import Countdown from "../Countdown"
import {Container} from "../../styled"
import PerkAvailableBlock from "../PerkAvailableBlock"
import {OnDealSubmit} from "../../../../../containers/DealInfo"

interface Props {
  availableDate: Moment
  redeemHeaderEmoji: string
  onClickRedeem: OnDealSubmit
}

interface State {
  load?: Promise<any> | null
  days: number
  hours: number
  min: number
  sec: number
}

class PerkNotAvailableBlock extends PureComponent<Props, State> {
  state = {
    load: hangPromise(),
    days: 0,
    hours: 0,
    min: 0,
    sec: 0
  }

  interval: any

  componentDidMount() {
    // update every second
    this.interval = setInterval(() => {
      const date = calculateCountdown(this.props.availableDate)
      if (date) {
        this.setState(date)
      } else {
        this.stop()
      }
    }, 1000)

    setTimeout(() => {
      this.setState({load: Promise.resolve()})
    }, 1000)
  }

  componentWillUnmount() {
    this.stop()
  }

  stop() {
    clearInterval(this.interval)
  }

  render() {
    const {redeemHeaderEmoji, onClickRedeem} = this.props
    const {load, days, hours, min, sec} = this.state

    return (
      <Container>
        <Loading load={load}>
          {days === 0 && hours === 0 && min === 0 && sec === 0 ? (
            <PerkAvailableBlock redeemHeaderEmoji={redeemHeaderEmoji} onClickRedeem={onClickRedeem} />
          ) : (
            <>
              <H4 textAlign="center">
                <FormattedMessage id="perks.redemptionEvents.perkNotAvailableBlock.header" />
              </H4>
              <Countdown days={days} hours={hours} min={min} sec={sec} />
              <Button large full disabled>
                <FormattedMessage id="perks.redemptionEvents.perkNotAvailableBlock.buttonText" />
              </Button>
            </>
          )}
        </Loading>
      </Container>
    )
  }
}

export default PerkNotAvailableBlock
